import React from 'react';
import {Link} from 'react-router-dom';

import Form from '../../components/common/Form';
import {getJwt} from '../../services/authService';
import TeamTablesManage from './teams/TeamTablesManage';
import SharedTablesManage from './teams/SharedTablesManage';
import {teams_data} from "../constants/constants";

import * as authService from "../../services/authService";
import http from "../../services/httpService";

import toastr from "toastr";
import ReactGA from "react-ga";
import Joyride, {STATUS} from "react-joyride";

class Teams extends Form {
    constructor(props) {
        //console.log("Teams teams_data", teams_data);
        super(props);
        this.state = {
            done: false,
            data: {
                teams: [],
                feeds_shared: [],
                teams_in: []
            },
            team_added: {},
            errors: {},

            //tour settings
            tourRun: false,
            steps: [
                {
                    content: 'Click here to invite your teammates as Team Admins 😃',
                    placement: 'top',
                    spotlightPadding: 0,
                    disableBeacon: true,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.teams-tour-step-1',
                    title: '',
                },

                {
                    content: "You\'re ready to manage your teammates now!\n" +
                        '\n' +
                        "If you need any assistance, I\'ll be just a click away in the bottom right corner of your screen. 😉",
                    placement: 'center',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.teams-tour-step-2',
                    title: '',
                },
            ],
            user: this.props.user,
            limitsReached: ''
        };

    }

    checkLimitations = () => {
        let limitsReached = []
        if (this.state.data && this.state.data.teams && this.state.data.teams.data && this.state.data.teams.data.length) {
            this.state.data.teams.data.map(team => {
                    //console.log('team: ', team)
                    let teamData = {
                        id: team.id,
                        name: team.team_name,
                        teamMemberCount: '',
                        teamMemberMax: '',
                        teamLimitReached: false,
                        workspaces: []
                    }
                    //for adding team member purposes
                    let teamAdminCount = team.admins.length + team.pending_admins.length
                    let workspacesAdminsCount = 0


                    //console.log('teamAdminCount1: ', teamAdminCount)
                    let fullWorkspacesInTeam = []

                    //CREATING ARRAY WITH FULL DATA OF ALL WORKSPACES IN THIS TEAM

                    if (this.state.user && this.state.user.sources) {
                        team.feeds.map(teamFeed => {
                            workspacesAdminsCount = workspacesAdminsCount + teamFeed.admins.length + teamFeed.pending_admins.length
                            let teamFound = this.state.user.sources.data.find(userSource => {
                                return userSource.name === teamFeed.name
                            })
                            fullWorkspacesInTeam.push(teamFound)
                        })
                        // console.log('workspacesAdminsCount: ', workspacesAdminsCount)
                        // console.log('fullWorkspacesInTeam: ', fullWorkspacesInTeam)

                        teamAdminCount = teamAdminCount + workspacesAdminsCount
                        //console.log('finalTeamAdminCount: ', teamAdminCount)
                        //
                        let unlimitedCheckTeam = ''
                        if (fullWorkspacesInTeam.length > 0) {
                            //console.log('there is data')
                            unlimitedCheckTeam = fullWorkspacesInTeam.find(userSource => {
                                //console.log('userSource: ', userSource)
                                if(userSource.plan && userSource.plan.additional_features && userSource.plan.additional_features.team_members){
                                    return userSource.plan.additional_features.team_members === "Unlimited"
                                }
                            })
                            //console.log('check if workspace has unlimited unlimitedCheckTeam: ', unlimitedCheckTeam)
                            unlimitedCheckTeam = unlimitedCheckTeam !== undefined
                        } else {
                            unlimitedCheckTeam = false
                        }

                        //console.log('unlimitedCheckTeam: ', unlimitedCheckTeam)


                        //TEAM LIMITATIONS HANDLING
                        let maxAdminsInTeam,
                            teamLimitReached
                        if (unlimitedCheckTeam) {

                            maxAdminsInTeam = 'Unlimited'
                            teamLimitReached = false
                        } else {

                            let arrayOfMaxAdmins = fullWorkspacesInTeam.map(fullWorkspaceInTeam => {
                                //console.log('fullWorkspaceInTeam.plan.additional_features.team_members: ', fullWorkspaceInTeam.plan.additional_features.team_members)
                                if( fullWorkspaceInTeam.plan && fullWorkspaceInTeam.plan.additional_features ){
                                    return Number(fullWorkspaceInTeam.plan.additional_features.team_members)
                                }
                            })
                            //console.log('arrayOfMaxAdmins: ', arrayOfMaxAdmins)
                            maxAdminsInTeam = Math.max(...arrayOfMaxAdmins)
                            teamLimitReached = maxAdminsInTeam <= teamAdminCount
                        }

                        teamData.teamAdminCount = teamAdminCount
                        teamData.teamAdminMax = maxAdminsInTeam
                        teamData.teamLimitReached = teamLimitReached

                        let workspaces = []
                        let workspace = {
                            name: '',
                            workspaceMaxAdmins: '',
                            workspaceAdminsCount: '',
                            workspaceLimitReached: '',
                        }
                        if (fullWorkspacesInTeam) {

                            fullWorkspacesInTeam.map(fullWorkspace => {

                                let workspaceInTeam = team.feeds.find(feed => {
                                    return feed.id === fullWorkspace.id
                                })
                                //console.log('workspaceInTeam: ', workspaceInTeam)

                                let workspaceMaxAdmins = fullWorkspace.plan && fullWorkspace.plan.additional_features ?
                                    fullWorkspace.plan.additional_features.team_members === 'Unlimited' ?
                                        'Unlimited' : Number(fullWorkspace.plan.additional_features.team_members) : '';
                                let workspaceAdminsCount = workspaceInTeam.admins.length + workspaceInTeam.pending_admins.length + team.admins.length + team.pending_admins.length
                                let workspaceLimitReached

                                if (workspaceMaxAdmins === 'Unlimited') {
                                    workspaceLimitReached = false
                                } else {
                                    workspaceLimitReached = workspaceAdminsCount >= workspaceMaxAdmins
                                }

                                workspaces.push(
                                    {
                                        id: fullWorkspace.id,
                                        name: fullWorkspace.name,
                                        workspaceLimitReached: workspaceLimitReached,
                                        workspaceMaxAdmins: workspaceMaxAdmins,
                                        workspaceAdminsCount: workspaceAdminsCount,
                                    }
                                )
                            })

                        }
                        teamData.workspaces = workspaces

                        limitsReached = [...limitsReached, teamData]
                    }
                }
            )

        }
        //console.log('limitsReached: ', limitsReached)
        this.setState({
            limitsReached
        })
    }
    componentDidMount = async () => {
        // ReactGA.pageview(window.location.pathname + window.location.search);
        if (this.props.location.state) {
            if (this.props.location.state === 'workspace-settings-tutorial') {
                setTimeout(
                    () => {
                        this.setState({
                            tourRun: true
                        })
                    },
                    1000
                )
            }
        }
        // console.log(('api/user/'+authService.getCurrentUserId()+'/team'));
        const result = await http.get('api/user/' + authService.getCurrentUserId() + '/teams', {headers: {authorization: getJwt()}});
        // console.log("componentDidMount result", result);
        const data = result.data;

        // console.log("DATA RESP", data);
        if (!data) {
            toastr.error("User id does not match. :(  Please log in again.");
            this.props.history.push('/logout');
        }
        this.setState({data: data});
        if (data.teams) {
            this.props.appPropagateTeams(data);
        }
        this.checkLimitations()
    }

    componentDidUpdate = () => {
        if (this.state.team_added !== this.props.team_added) {
            this.setState({
                team_added: this.props.team_added
            });
        }

        if (this.state.data.teams.data !== this.props.teams) {

            this.setState({
                data: {
                    ...this.state.data,
                    teams: {
                        data: this.props.teams
                    }
                }
            });
        }
        if (this.state.data.teams_in.data !== this.props.teams_in) {
            this.setState({
                data: {
                    ...this.state.data,
                    teams_in: {
                        data: this.props.teams_in
                    }
                }
            });
        }
        if (this.state.user !== this.props.user) {
            this.setState({
                user: this.props.user
            })
            this.checkLimitations()
        }
    }

    getTeams = async () => {

        try {
            const result = await http.get('api/user/' + authService.getCurrentUserId() + '/teams', {headers: {authorization: getJwt()}});
            // console.log("componentDidMount result", result);
            const data = result.data;

            // console.log("DATA RESP", data);
            if (!data) {
                toastr.error("User id does not match. :(  Please log in again.");
                this.props.history.push('/logout');
            }
            this.setState({data: data});
            if (data.teams) {
                this.props.appPropagateTeams(data);
            }
        } catch (e) {
            toastr.error('Error with loading Teams')
        }
    }
    handleJoyrideCallback = (data) => {
        //console.log('joyride callback data: ', data)

        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.setState({tourRun: false});
        }

    }
    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };

    render() {
        // console.log("render this.state.data", this.state.data);
        const {teams, feeds_shared, teams_in} = this.state.data;
        //console.log('teams - feeds shared: ', feeds_shared)
        // console.log("render this.state.team_added", this.state.team_added);
        const {tourRun, steps} = this.state
        return (
            <div>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous={true}
                    getHelpers={this.getHelpers}
                    run={tourRun}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={steps}
                    styles={{
                        options: {
                            zIndex: 10000,
                            primaryColor: '#26AAE1'
                        },
                    }}
                />
                <div className="flex-direction-row space-between">
                    <h1 className='main-title'>Teams</h1>
                </div>

                <div className="create-new-team-container">
                    <Link to='/workspace-settings'>{'< Workspace Settings'}</Link>
                    <button
                        id="add-new-team-header-button" className='btn-action'
                        onClick={() => {
                            localStorage.setItem("navigateBackTo", '/teams');
                            this.props.history.push('/create-team')
                        }}
                    >
                        Create New Team
                    </button>
                </div>
                {/*{console.log('teams data: ', this.props.user,this.state.data.teams, this.state.data.teams_in, this.props.selectedSource, this.props, teams, teams_in)}*/}
                {teams.data && teams.data.map((team, index) =>
                    <TeamTablesManage {...this.props} key={index} user={this.props.user}
                                      type="teams" teams={this.state.data.teams} teams_in={this.state.data.teams_in}
                                      sources={this.props.sources}
                                      selectedSource={this.props.selectedSource}
                                      selectedSourceName={this.props.selectedSourceName}
                                      updateUserFromServer={this.props.updateUserFromServer}
                                      team={team} openModal={this.props.openModal} getTeams={this.getTeams}
                                      limitsReached={this.state.limitsReached}
                                      checkLimitations={this.checkLimitations}
                                      history={this.props.history}
                    />
                )}
                {teams_in.data && teams_in.data.map((team_in, index) =>
                    <TeamTablesManage {...this.props} key={index} user={this.props.user}
                                      type="teams_in" teams={this.state.data.teams}
                                      teams_in={this.state.data.teams_in}
                                      sources={this.props.sources}
                                      selectedSource={this.props.selectedSource}
                                      selectedSourceName={this.props.selectedSourceName}
                                      updateUserFromServer={this.props.updateUserFromServer}
                                      team={team_in} openModal={this.props.openModal} getTeams={this.getTeams}
                                      limitsReached={this.state.limitsReached}
                                      checkLimitations={this.checkLimitations}
                                      history={this.props.history}
                    />
                )}
                {this.state.team_added && this.state.team_added.id ?
                    <TeamTablesManage {...this.props} key="new_team" user={this.props.user}
                                      type="team_added" teams={this.state.data.teams}
                                      teams_in={this.state.data.teams_in}
                                      sources={this.props.sources}
                                      selectedSource={this.props.selectedSource}
                                      selectedSourceName={this.props.selectedSourceName}
                                      team={this.state.team_added} openModal={this.props.openModal}
                                      updateUserFromServer={this.props.updateUserFromServer}
                                      getTeams={this.getTeams}
                                      limitsReached={this.state.limitsReached}
                                      checkLimitations={this.checkLimitations}
                                      history={this.props.history}
                    />
                    :
                    ""
                }

                {
                    feeds_shared && feeds_shared.length ?
                        <SharedTablesManage feeds={feeds_shared} openModal={this.props.openModal}
                                            updateUserFromServer={this.props.updateUserFromServer}/>
                        :
                        ''
                }
            </div>
        )
    }
}

export default Teams